<template>
  <div class="content edit-page minus-margin20">
    <CommonStep :step-list="stepList"></CommonStep>
    <el-row class="content-2-col" id="rightForm">
      <template v-if="showCardStep === 1">
        <ContentBox title="选择所属计划" class="content-box">
          <SelectTree :planType="planType" @orderSchedule="handleOrderSchedule"></SelectTree>
        </ContentBox>
        <ContentBox class="content-box">
          <el-button plain @click="$emit('go-back')">取消</el-button>
          <el-button type="primary" :disabled="isDisabeld" @click="goNextStep">下一步</el-button>
        </ContentBox>
      </template>
      <template v-if="showCardStep === 2">
        <ContentBox title="所属项目计划">
          <el-form class="demo-ruleForm" label-width="117px" label-position="left">
            <el-form-item label="订单名称">{{ scheduleForm.orderName }}</el-form-item>
            <el-form-item label="计划名称">{{ scheduleForm.scheduleName }}</el-form-item>
          </el-form>
        </ContentBox>
        <!-- 程序化创意表单 -->
        <MaterialProgrammatic
          v-if="scheduleForm.scheduleSource !== 0"
          ref="programmatic"
          :sdkProviderList="sdkProviderList"
          :scheduleForm="scheduleForm"
          @go-back="$emit('go-back')"
        />
        <!-- 自有源创意表单 -->
        <MaterialOwnSource
          v-else
          :sdkProviderList="sdkProviderList"
          :scheduleForm="scheduleForm"
          @go-back="$emit('go-back')"
        />
      </template>
    </el-row>
  </div>
</template>
<script>
import CommonStep from '@/components/common/CommonStep'
import SelectTree from '@/components/SelectTree'
import MaterialProgrammatic from './MaterialProgrammatic.vue'
import MaterialOwnSource from './MaterialOwnSourse.vue'

export default {
  components: {
    CommonStep,
    SelectTree,
    MaterialProgrammatic,
    MaterialOwnSource
  },
  data() {
    return {
      stepList: [
        {
          parent: '选择计划',
          status: this.mode === 'edit' ? '2' : '1',
          children: [
            {
              label: '选择计划',
              status: this.mode === 'edit' ? '2' : '1'
            }
          ]
        },
        {
          parent: '素材创意',
          status: this.mode === 'edit' ? '1' : '0',
          children: [
            {
              label: '素材上传',
              status: '0'
            }
          ]
        }
      ],
      isDisabeld: true, // 下一步是否可点击
      isShowCommonUpload: false,
      mediaForm: {
        mediaAddUpdateVOList: [],
        operateFlag: 1,
        partnerId: '',
        scheduleId: '',
        shareTrack: 0,
        settlementProvider: undefined,
        settlementType: 0
      },
      scheduleForm: {
        orderName: '',
        scheduleName: '',
        partnerId: '',
        spaceId: '',
        spaceNo: '',
        scheduleId: '',
        scheduleSource: '',
        supportMode: '',
        mediaId: '',
        recId: undefined
      },
      showCardStep: 1
    }
  },
  props: ['mode', 'id', 'materiaObj', 'planType', 'sdkProviderList'],
  methods: {
    handleOrderSchedule(data) {
      this.isDisabeld = !data.scheduleId
      this.mediaForm.partnerId = data.partnerId
      this.mediaForm.scheduleId = data.scheduleId
      this.scheduleForm.orderName = data.orderName
      this.scheduleForm.scheduleName = data.scheduleName
      this.scheduleForm.partnerId = data.partnerId
      this.scheduleForm.spaceId = data.spaceId
      this.scheduleForm.spaceNo = data.spaceNo
      this.scheduleForm.scheduleId = data.scheduleId
      this.scheduleForm.scheduleSource = data.scheduleSource
      this.scheduleForm.supportMode = data.supportMode
      this.scheduleForm.recId = data.recId
    },
    goNextStep() {
      this.showCardStep = 2
      this.isShowCommonUpload = true
      let index = this.stepList.findIndex((item) => item.status === '1')
      this.stepList[index].status = '2'
      this.stepList[index].children.forEach((item) => {
        item.status = '2'
      })
      this.stepList[index + 1].status = '1'
      this.stepList[index + 1].children.forEach((item) => {
        item.status = '1'
      })
    }
  },
  created() {
    if (this.mode === 'edit') {
      this.showCardStep = 2
      this.scheduleForm.orderName = this.materiaObj.orderName
      this.scheduleForm.scheduleId = this.materiaObj.scheduleId
      this.scheduleForm.scheduleName = this.materiaObj.scheduleName
      this.scheduleForm.scheduleSource = this.materiaObj.scheduleSource
      this.scheduleForm.supportMode = this.materiaObj.supportMode
      this.scheduleForm.partnerId = this.materiaObj.partnerId
      this.scheduleForm.spaceId = this.materiaObj.spaceId
      this.scheduleForm.spaceNo = this.materiaObj.spaceNo
      this.scheduleForm.mediaId = this.materiaObj.mediaId
      this.scheduleForm.recId = this.materiaObj.recId
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  display flex
  flex-direction row
  height 100%
.content-2-col
  width calc(100% - 132px)
  padding 16px
  overflow auto
.demo-ruleForm
  // max-width: 800px;
.demo-ruleForm >>>.el-select
  display flex
.edit-page
  overflow hidden
  height calc(100vh - 60px)
</style>
